import styled from '@emotion/styled'
import { withClass } from 'common/emotion'
import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { metrics, colors } from 'component-library/__styling/settings'

const articleBreachClassName = 'feature-article-breach-notification'

interface StyledFeatureArticleBreachWrapperProps {
    /* show background when its premium and they are not logged in */
    showBackground: boolean
}

export const StyledFeatureArticleBreachNotification = withClass(articleBreachClassName)(
    styled('div')({
        width: '100%',
        marginTop: calcRem(metrics.thewest.textMargin / 2),

        '& > div': {
            paddingTop: 0,

            [breakpoint('md')]: {
                paddingLeft: calcRem(96),
                paddingRight: calcRem(96),
            },

            [breakpoint('lg')]: {
                paddingLeft: calcRem(192),
                paddingRight: calcRem(192),
            },

            [breakpoint('xl')]: {
                paddingLeft: calcRem(288),
                paddingRight: calcRem(288),
            },
        },
    })
)

export const StyledFeatureArticleBreachWrapper = styled('div')<
    StyledFeatureArticleBreachWrapperProps
>(({ showBackground }) => {
    return {
        backgroundColor: showBackground ? colors.thewest.breachNavy : undefined,

        // Need to set this otherwise we get a green line above the hero,
        // due to the aspect ratio not fitting against the viewport width
        // downside is a line below the image, but not really noticable
        picture: {
            backgroundColor: showBackground ? colors.thewest.greyMouse : undefined,
        },

        // Override if showBackground active
        '.figcaption': showBackground
            ? {
                  svg: {
                      fill: colors.white,
                  },
                  span: {
                      color: colors.white,
                  },
              }
            : {},
    }
})
